module.exports = __webpack_public_path__ + "img/xu5-1.5d0b82e6.png";